// This function uses DOMPurify to sanitize an HTML string to prevent XSS attacks upon parsing HTML string w/in the app

import DOMPurify from "dompurify";

export function cleanHTML(rawString) {
    return DOMPurify.sanitize(rawString, { USE_PROFILES: { html: true }, ADD_ATTR: ['target'] });
}